import axios from './axios';

export const getByCode = async code => {
  const campaign = (await axios.get(`/campaign/code/${code}`)).data;
  return campaign;
};
